import * as React from 'react'
// import { dateFormat } from '../../util'
// import * as moment from 'moment'
import Checkbox from '../../components/Checkbox'
import './index.css'

class Subscribe extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
        this.state = {}
    }
    handleCheckboxChange(index: any, checked: any, ind: number) {
        const {handleCheckboxChange} = this.props
        handleCheckboxChange(index, checked, ind)
    }
    showCheckbox(index: any) {
        const {showCheckbox} = this.props
        showCheckbox(index)
    }

    render() {
        const {subscribes} = this.props
        return(
            <div className="filterTypeList">
                {
                    subscribes.map((type: any, index: number) =>
                        <section className="filter-type" key={index}>
                            <div className="filter-type-name" onClick={() => this.showCheckbox(index)}>
                                <p>{type.type}</p>
                                <span>
                                    {
                                        type.checked === true ?
                                            <i className="fa fa-angle-up"/>
                                            : <i className="fa fa-angle-down"/>
                                    }
                                </span>
                            </div>
                            {
                                type.checked === true && type.value.map((item: any, ind: number) =>
                                    <div className="subscribe-item" key={item.id}>
                                        <Checkbox
                                            checked={item.checked}
                                            handleCheckboxChange={() => this.handleCheckboxChange(index, item.checked, ind)}
                                            id={'checkbox-' + item.id.toString()}
                                        />
                                        <p>{item.title}</p>
                                    </div>
                                )
                            }
                        </section>
                    )
                }
            </div>
        )
    }
}
export default Subscribe



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Subscribe/index.tsx